import { useQuery } from '@tanstack/react-query';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/**
 * The org-wide user directory (`GET /user`), available to everyone — distinct
 * from `useAdminUsers` (`listAdminUsers`, admin-scoped). Detail hydration is
 * pull-based: `useUser` reads its `initialData` straight out of this cache
 * (or `useAdminUsers`'s) rather than this hook write-through seeding
 * `users.detail` as a side effect.
 */
export function useUsersList() {
  return useQuery({
    queryKey: queryKeys.users.list(),
    queryFn: ({ signal }) => userApiClient.getUsers(toCancelToken(signal)),
    staleTime: 5 * 60_000,
  });
}
